import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const setup = Loadable(() => import('../../containers/web/setup'));
export default MapTo('vcg/components/soe-home/react/setup')(setup);
